<template>
  <div class="base-radio-checkbox">
    <label :for="id" class="base-radio-checkbox__container">
      <input
        v-model="proxyModel"
        :value="value"
        class="base-radio-checkbox__input"
        v-bind="mergedAttrs"
        :aria-labelledby="`${id}-label`">
      <span :id="`${id}-label`" class="body-smaller-semi-bold">{{ labelText }}</span>
    </label>
    <div
      v-show="errors.length"
      :id="`${id}-error`"
      class="body-smaller base-radio-checkbox__error">
      <oie-base-icon icon="warning" size="xs"></oie-base-icon>
      <span v-for="error in errors" :key="error"> {{ error }}</span>
    </div>
    <div
      v-show="description"
      :id="`${id}-description`"
      class="body-smaller"
      v-html="description">
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      type: [String, Boolean, Array, Object],
      required: false,
      default: null
    },
    value: {
      type: [String, Boolean, Array, Object],
      required: false,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    id() {
      return this.$attrs.id || _.uniqueId('base-radio-checkbox-')
    },
    inputType() {
      return _.isArray(this.modelValue) || _.isBoolean(this.modelValue) ? 'checkbox' : 'radio'
    },
    labelText() {
      return this.required ? `${this.label}*` : this.label
    },
    mergedAttrs() {
      return {
        id: this.id,
        type: this.inputType,
        'aria-required': this.required ? 'true' : 'false',
        'aria-invalid': this.errors.length ? 'true' : 'false',
        'aria-describedby': `${this.id}-error ${this.id}-description`,
        ...this.$attrs
      }
    },
    proxyModel: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('change', value)
      }
    }
  }
}
</script>

<style lang="scss">

// General
.base-radio-checkbox {
  display: flex;
  flex-direction: column;
  gap: measure(quarter);
}

.base-radio-checkbox__container {
  display: flex;
  align-items: center;
  gap: measure(quarter);

}

.base-radio-checkbox__input {
  height: 24px;
  width: 24px;
  accent-color: color(brand-blue-2);
}

// Error styles
.base-radio-checkbox__input[aria-invalid='true'] {
  accent-color: color(text-red);
}

.base-radio-checkbox__error {
  display: flex;
  align-items: center;
  gap: measure(eighth);
  flex-wrap: wrap;
  color: color(text-red);
}
</style>
